import { useEffect } from 'react'

import { useAppDispatch } from '../../../../store'
import { setLatestFeedbackOnScreen } from '../../../../store/slices/uiSlice'
import type { IndividualSessionFeedbackData } from '../../../../types/IndividualSessionFeedbackTypes'

/** Tells the floating assistant whose feedback is on screen, for as long as it is, so Aria can greet it. */
export function useLatestFeedbackOnScreen(
  feedbackData: IndividualSessionFeedbackData | undefined,
  isShown: boolean
): void {
  const dispatch = useAppDispatch()
  // An older game shown while the newest one is still being analysed is not their latest session.
  const isLastPlayedSessionShown = isShown && feedbackData?.isLastPlayedSession === true
  const shownSessionId = isLastPlayedSessionShown ? feedbackData?.sessionId : undefined

  useEffect(() => {
    if (!shownSessionId) return

    dispatch(setLatestFeedbackOnScreen(shownSessionId))

    return () => {
      dispatch(setLatestFeedbackOnScreen(undefined))
    }
  }, [dispatch, shownSessionId])
}
